var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 17.8571,
    rx: 1,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 18
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 17.8571,
    rx: 1,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 17.8571,
    fill: "#0A17A7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95867 11.9044L-2.47656 17.594L-1.14515 19.5679L9.52369 12.3717V19.0473H15.4761V12.3717L26.145 19.568L27.4764 17.5941L19.0411 11.9044H24.9999V5.95202H19.0413L27.4764 0.262473L26.145 -1.71143L15.4761 5.48484V-1.19083H9.52369V5.48483L-1.14512 -1.71138L-2.47654 0.262524L5.9585 5.95202H-0.000115633V11.9044H5.95867Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6677 5.65369L27.9761 -1.78577",
    stroke: "#DB1F35",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8687 12.2299L28.006 19.0627",
    stroke: "#DB1F35",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14785 5.63447L-3.42627 -1.49182",
    stroke: "#DB1F35",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29473 12.1473L-3.42627 19.9202",
    stroke: "#DB1F35",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.7143H10.7143V17.8571H14.2857V10.7143H25V7.14286H14.2857V0H10.7143V7.14286H0V10.7143Z",
    fill: "#E6273E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.19b45f13399963a3a63cb8a7901482c7.svg";
export { ForwardRef as ReactComponent };